<template>
  <div class="pb-80">
    <div ref="contentArea">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SitterOnboarding',
  watch: {
    // Watch for route changes to update focus
    // If you don't do this, keyboard navigation will be forced into footer links
    $route() {
      this.focusFirstInteractive();
    },
  },
  methods: {
    focusFirstInteractive() {
      // Use nextTick to ensure DOM is fully updated
      this.$nextTick(() => {
        const contentArea = this.$refs.contentArea as HTMLElement;
        if (!contentArea) return;

        const firstInteractive = contentArea.querySelector(
          'input, button, a[href], textarea, select, [tabindex="0"]'
        ) as HTMLElement;
        if (firstInteractive) {
          firstInteractive.focus();
        }
      });
    },
  },
};
</script>
